class PlpFaqData extends HTMLElement {
  constructor() {
    super();
    this.questionsContent = this.querySelectorAll('.accordion__title');
    this.answersContent = this.querySelectorAll('.accordion__content');
    
    this.handleCollection = this.dataset.handleCollection;
  }

  connectedCallback() {
    this.fetchData();
  }

  async fetchData() {
    if(this.handleCollection === undefined || this.handleCollection === '') return;
    try {
      const response = await fetch(`https://api.wordlift.io/data/https/${window.location.host}/collections/${this.handleCollection}`);
  
      if (!response.ok) {
        throw new Error(`Errore HTTP: ${response.status}`);
      }
      // Parse JSON response
      const data = await response.json();

      let faqData;
      if (Array.isArray(data)) {
        if (data.length === 0) {
          console.warn('PlpFaqData.fetchData: No data returned for handleCollection=', this.handleCollection);
          this.style.display = "none";
          return;
        }
        faqData = data[0];
      } else {
        faqData = data;
      }
/*       console.log('PlpFaqData.fetchData: raw response data:', data);
      console.log('PlpFaqData.fetchData: faqData:', faqData);
      console.log('PlpFaqData.fetchData: mainEntity:', faqData.mainEntity);
      console.log('PlpFaqData.fetchData: mainEntity length:', Array.isArray(faqData.mainEntity) ? faqData.mainEntity.length : 'undefined'); */
      if (!faqData || !faqData.mainEntity) {
        console.warn('PlpFaqData.fetchData: No FAQs found for handleCollection=', this.handleCollection);
        this.style.display = "none";
        return;
      }
 
      this.renderProducts(faqData);
      this.insertJsonLd(faqData);
      
    } catch (error) {
      this.style.display = "none";
      console.error("Errore nella fetch:", error);
    }
  }
  
  insertJsonLd(faqData) {
    if (!faqData || !faqData.mainEntity) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.mainEntity || []
    });
    document.head.appendChild(script);
  }

  renderProducts(faqData) {
    if (!faqData || !faqData.mainEntity) return;
    const answers = faqData.mainEntity;
    answers.forEach((answer, i) => {
      this.questionsContent[i].innerHTML = answer.name;
      this.answersContent[i].innerHTML = answer.acceptedAnswer.text;
    });
  }
}

customElements.define('plp-faq-data', PlpFaqData);